<template>
<div class="order-list">
    <div class="academy-profile-big-card">
        <div class="academy-profile-title flex">
            <div> 订单记录 </div>
            <div>
            </div>
            <div class="btn-info flex">
                <el-button type="primary" style="margin-right: 20px;" @click="orderListData">刷新</el-button>
                <el-button type="primary" style="margin-right: 20px;" @click="presentedOrder">赠送码兑换</el-button>
                <el-button type="primary" @click="convertOrder">平台兑换</el-button>
            </div>

            </div?>

            <el-table height=" calc(100vh - 364px)" style="width: 100%;overflow: auto;" :data="orderData">
                <el-table-column prop="goodTitle" align="center" label="商品名称" min-width="180">
                </el-table-column>
                <el-table-column prop="province" align="center" label="商品类型">
                    <template slot-scope="scope">
                        <div v-if="scope.row.goodDict == '101'">课程 </div>
                        <div v-if="scope.row.goodDict == '201'">服务 </div>
                        <div v-if="scope.row.goodDict == '301'">文库 </div>
                        <div v-if="scope.row.goodDict == '401'">咨询 </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="orderNo" label="订单号" min-width="180">
                </el-table-column>
                <el-table-column align="center" prop="orderFee" label="订单金额">
                </el-table-column>
                <el-table-column align="center" prop="createDate" label="支付时间">
                </el-table-column>

                <el-table-column align="center" prop="payFlag" label="	订单状态">

                    <template slot-scope="scope">
                        <span v-if="scope.row.backFlag && scope.row.backFlag == 1">已退款</span>
                        <span v-else-if="scope.row.payFlag && scope.row.payFlag == 1">已支付</span>
                        <span v-else>未支付</span>
                    </template>
                </el-table-column>

                <el-table-column prop="province" align="center" label="资料" min-width="200">

                    <template slot-scope="scope">
                        <div style="padding: 10px 0" v-if="scope.row.backFlag==0">
                            <div v-if="scope.row.cloudUrl != '' || scope.row.cloudCode != ''" class="blue">
                                <span v-if="scope.row.preview == 0" @click="previewOrder(scope.row, 1)">查看</span>
                                <span v-else @click="previewOrder(scope.row, 0)">隐藏</span>
                            </div>
                            <div v-if="scope.row.preview == 1">
                                <div>网盘地址：{{ scope.row.cloudUrl }}</div>
                                <div>提取码：{{ scope.row.cloudCode }}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="province" label="操作" min-width="100">

                    <template slot-scope="scope">
                        <div style="padding: 10px 0">
                            <div style="color:#0396F9;line-height: 30px " v-if="scope.row.payFlag == 1 && scope.row.backFlag != 1" class="pointer" @click="orderDetail(scope.row)">详情 </div>
                            <div style="color:#0396F9;line-height: 30px " @click="getOrderGiveListData(scope.row)" class="pointer" v-if="scope.row.payFlag == 1 && scope.row.backFlag != 1 && scope.row.giveFlag == 1">查看赠品
                            </div>
                            <div style="color:#0396F9" v-else-if="scope.row.payFlag != 1" class="pointer" @click="deleteOrder(scope.row.id)">删除订单 </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination v-if="orderTotalSize > 20" background :page-size="20" @current-change="changeOrder" layout="prev, pager, next" :total="orderTotalSize">
            </el-pagination>
        </div>

        <div class=" orderDetail2">
            <el-drawer title="赠送商品列表" :visible.sync="giveOrderDetailModal">
                <div class="">
                    <el-table style="width: 100%" :data="giveOrderDetailList">
                        <el-table-column prop="goodTitle" align="left" label="商品名称">
                        </el-table-column>
                        <el-table-column prop="province" align="center" label="商品类型">

                            <template slot-scope="scope">
                                <div v-if="scope.row.goodDict == '101'">课程 </div>
                                <div v-if="scope.row.goodDict == '201'">服务 </div>
                                <div v-if="scope.row.goodDict == '301'">文库 </div>
                                <div v-if="scope.row.goodDict == '401'">咨询 </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="province" align="center" label="学习进度">

                            <template slot-scope="scope" v-if="scope.row.goodDict == '101'">
                                <div>{{ scope.row.studyPercent }}% </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="province" label="操作" width="100px">

                            <template slot-scope="scope" align="center">
                                <div style="color:#0396F9;line-height: 30px " v-if="scope.row.payFlag == 1 && scope.row.backFlag != 1" class="pointer" @click="orderDetail(scope.row)">详情 </div>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-pagination v-if="giveOrderDetailSize > 20" background :page-size="20" @current-change="changeGiveOrder" layout="prev, pager, next" :total="giveOrderDetailSize">
                    </el-pagination>

                </div>

            </el-drawer>
        </div>

        <div class="orderDetail" v-if="orderDetailInfo">
            <el-drawer title="订单详情" @close="showFlag" :visible.sync="orderDetailDrawer">
                <div class="orderDetailBox">
                    <div class="orderDetailCon">
                        <p class="font-size-smg">基本信息</p>
                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL">订单号</div>
                            <div v-if="orderDetailInfo.orderNo">{{ orderDetailInfo.orderNo }}</div>
                        </div>
                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL">订单状态</div>
                            <div v-if="orderDetailInfo.payFlag == 1" class="buy">已购买</div>
                            <div v-else class="buy buy2">未支付</div>
                        </div>
                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL">下单时间</div>
                            <div>{{ orderDetailInfo.createDate }}</div>
                        </div>
                    </div>

                    <div class="orderDetailCon" style="text-align: left">
                        <p class="font-size-smg">购买信息</p>
                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL">购买课程</div>
                            <div class="flex" style="flex: 1">
                                <img :src="orderDetailInfo.goodCover" alt="">
                                <div style="flex: 1;text-align: left">
                                    <p>{{ orderDetailInfo.goodTitle }}</p>
                                    <p>￥{{ orderDetailInfo.price }}</p>
                                </div>

                            </div>
                        </div>
                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL">支付金额</div>
                            <div>￥{{ orderDetailInfo.orderFee }}</div>
                        </div>
                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL">购买人</div>
                            <div>{{ orderDetailInfo.buyerName }}</div>
                        </div>

                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL">订单来源</div>
                            <div v-if="orderDetailInfo.orderChannelDict == 'zhibo'">直播</div>
                            <div v-else-if="orderDetailInfo.orderChannelDict == 'guazai'">视频挂载</div>
                            <div v-else-if="orderDetailInfo.orderSourceDict == 'doudian'">抖店</div>
                            <div v-else>平台订单</div>
                        </div>

                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL">支付时间</div>
                            <div>{{ orderDetailInfo.updateDate }}</div>
                        </div>

                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL">手机号</div>
                            <div>{{ orderDetailInfo.buyerMobile }}</div>
                        </div>
                    </div>
                    <!-- orderDetailInfo.goodDict != 301&& -->
                    <div class="orderDetailCon" v-if="giveOrderDetailModal==true">
                        <p class="font-size-smg">素材内容</p>
                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL">网盘地址</div>
                            <div>{{ orderDetailInfo.cloudUrl }}</div>
                        </div>
                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL">提取码</div>
                            <div>{{ orderDetailInfo.cloudCode }}</div>
                        </div>
                    </div>
                    <div class="orderDetailCon" v-else-if="orderDetailInfo.cloudUrl != '' || orderDetailInfo.cloudCode != ''">
                        <p class="font-size-smg">素材内容 <span class="blue" @click="previewCloud" v-if="showFlag == false">查看</span>
                            <span class="blue" v-if="showFlag == true" @click="showFlag=false; orderDetailInfo.preview=false;">隐藏</span>
                        </p>
                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL" style="width:140px;">网盘地址</div>
                            <div v-if="showFlag == true">{{ orderDetailInfo.cloudUrl }}</div>
                            <div v-else> ************************ </div>
                        </div>
                        <div class="orderDetailConItem font-size-smg flex">
                            <div class="conItemL" style="width:140px;">提取码</div>
                            <div v-if="showFlag == true">{{ orderDetailInfo.cloudCode }}</div>
                            <div v-else> **** </div>
                        </div>
                    </div>

                </div>

            </el-drawer>
        </div>

        <el-dialog class="convertOrderModal" title="绑定" :visible.sync="convertOrderModal" width="500px">
            <div>
                <el-form ref="form" label-width="60px">
                    <el-form-item label="手机号" class="flex">
                        <el-input v-model="orderBuyForm.mobile" placeholder="请输入平台购买的手机号码"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" class="flex">
                        <el-input style="margin-right: 20px" v-model="orderBuyForm.code" placeholder="请输入验证码"></el-input>
                        <el-button type="primary" v-if="verificateRule == true" @click="loginSendMsg">{{ verificationVal
                            }}</el-button>
                        <el-button type="primary" v-else>{{ verificate }}</el-button>
                    </el-form-item>
                </el-form>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="convertOrderModal = false">取 消</el-button>
                <el-button type="primary" @click="validMsg">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog class="convertOrderModal" title="请输入课程兑换码" :visible.sync="presentedOrderModal" width="500px">
            <div>
                <el-form ref="form" label-width="60px">
                    <el-form-item label="兑换码" class="flex">
                        <el-input v-model="orderBuyForm.code" placeholder="请输入课程兑换码"></el-input>
                    </el-form-item>
                </el-form>

            </div>
            <span slot="footer" class="dialog-footer" style="margin-top: -40px;padding-top: 0">
                <el-button @click="presentedOrderModal = false">取 消</el-button>
                <el-button type="primary">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import {
    findGoodDetailLookFlag
} from "@/api/good.js"
import {
    getLocalStorage
} from '@/utils/auth.js'
import {
    validMsg,
    sendMsg
} from "@/api/sms.js"
import {
    orderListData,
    deleteOrder,
    bindDoudian,
    orderGiveListData,
    updateOrderStudyFlag
} from "@/api/order"
export default {
    name: "order",
    data() {
        return {
            showFlag: false, //学习是否隐藏
            giveOrderDetailModal: false, //赠送单列表
            giveOrderDetailList: [], //赠送单列表
            giveOrderDetailSize: 0, //赠送单总数
            giveOrderDetailPage: 1, //赠送单页数
            giveOrderDetail: '', //赠送单页数父订单信息

            presentedOrderModal: false, //赠送订单
            presentedForm: {
                code: '' //赠送订单
            },
            smsTemplateCode: 'zsm.sms.template.userlogin', //短信模板
            verificate: '60s',
            verificationVal: '发送验证码',
            verificateRule: true, //是否获取验证码
            orderBuyForm: {
                mobile: '', //手机号
                code: '' //手机号
            },
            convertOrderModal: false, //兑换码弹框

            orderDetailDrawer: false, //是否显示
            orderDetailInfo: '', //订单详情
            orderData: [],
            orderPageNo: 1,
            orderTotalSize: 0
        }
    },
    watch: {
        orderDetailDrawer(newValue, oldValue) {
            this.showFlag = false;
        },
    },
    beforeMount() {
        this.orderListData()
    },
    methods: {
        /**
         * 修改订单学习状态
         * @param orderId  订单号
         */
        async previewOrder(orderInfo, preview) {
            // 查看课程观看条件
            let res = await findGoodDetailLookFlag(orderInfo.goodId);
            if (res.data) {
                let data = JSON.parse(res.data);
                if (orderInfo.watchSecs < data.studySecs * 60) {
                    this.$message({
                        message: `学习时长超过${data.studySecs}分才可解锁学习资料`,
                        type: 'error'
                    })
                    return false
                }
            }
            this.showFlag = true;
            this.orderData.map((item) => {
                if (item.id == orderInfo.id) {
                    item.preview = preview
                }
            })
            if (orderInfo.goodDict == '301' && preview == 1) {
                let res = await updateOrderStudyFlag(orderInfo.id)
            }
        },
        // 查看网盘内容
        previewCloud() {
            this.previewOrder(this.orderDetailInfo, 1)
        },
        changeGiveOrder(pageNo) {
            this.giveOrderDetailPage = pageNo
            this.getOrderGiveListData(this.giveOrderDetail)
        },
        //获取订单列表
        async getOrderGiveListData(orderInfo) {

            if (orderInfo.refundApplyFlag == 1 && orderInfo.refundProgress != 'reject') {
                this.$message({
                    message: '申请退款期间不可观看/下载作品内容',
                    type: 'error'
                })
                return false
            }
            // 查看课程观看条件
            let res = await findGoodDetailLookFlag(orderInfo.goodId);
            if (res.data) {
                let data = JSON.parse(res.data);
                if (orderInfo.watchSecs < data.totalSecs) {
                    this.$message({
                        message: `请观看完主订单打卡章节后才可解锁此赠品`,
                        type: 'error'
                    })
                    return false
                }
            }
            let data = await orderGiveListData({
                orderId: orderInfo.id,
                pageNo: this.giveOrderDetailPage
            })
            this.giveOrderDetailSize = data.count
            this.giveOrderDetailList = data.list
            this.giveOrderDetailModal = true;
            this.giveOrderDetail = orderInfo
        },
        //校验验证码
        async validMsg() {
            if (this.orderBuyForm.mobile.length !== 11) {
                this.$message({
                    showClose: true,
                    message: '请输入正确的手机号',
                    type: 'error'
                })
                return false
            }
            if (this.orderBuyForm.code == '') {
                this.$message({
                    showClose: true,
                    message: '请输入验证码',
                    type: 'error'
                })
                return false
            }
            let info = {
                inputCode: this.orderBuyForm.code,
                mobile: this.orderBuyForm.mobile,
                msgDict: this.smsTemplateCode
            }
            let validMsgInfo = await validMsg(info);
            if (validMsgInfo.result == 'true') {
                this.bindDoudianByMobile()
            } else {
                this.$message({
                    message: validMsgInfo.message,
                    type: 'error'
                })
            }
        },

        // 发送验证码
        loginSendMsg() {
            if (this.orderBuyForm.mobile.length !== 11) {
                this.$message({
                    showClose: true,
                    message: '请输入正确的手机号',
                    type: 'error'
                })
                return false
            }

            sendMsg({
                mobile: this.orderBuyForm.mobile,
                msgDict: this.smsTemplateCode
            }).then(res => {
                if (res.result == 'true') {
                    let timer2 = 60
                    this.verificateRule = false
                    let Timer = setInterval(() => {
                        if (timer2 > 1) {
                            timer2--
                            this.verificate = timer2 + 's'
                        } else {
                            timer2 = 60
                            this.verificationVal = '请重新获取验证码'
                            this.verificate = timer2 + 's'
                            this.verificateRule = true
                            clearInterval(Timer)
                            Timer = null
                        }
                    }, 1000)
                    this.$message({
                        message: '发送成功',
                        type: 'success'
                    })
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    })
                }
            })

        },

        // 绑定抖店订单
        bindDoudianByMobile() {
            if (getLocalStorage('buyerId')) {
                let info = {
                    mobile: this.orderBuyForm.mobile,
                    frontId: getLocalStorage('buyerId')
                }
                bindDoudian(info).then((res) => {
                    if (res.result == 'true') {
                        this.convertOrderModal = false
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            } else {
                this.$message({
                    showClose: true,
                    message: '当前账户无法兑换',
                    type: 'error'
                })
            }

        },
        presentedOrder() {
            this.$message({
                showClose: true,
                message: '暂未开放',
                type: 'error'
            })
            // this.presentedOrderModal=true
        },
        // 绑定抖店订单弹框
        convertOrder() {
            this.convertOrderModal = true
        },
        //删除订单
        async deleteOrder(id) {
            let deleteOrderInfo = await deleteOrder(id);
            if (deleteOrderInfo.result == 'true') {
                this.orderListData()
                this.$message({
                    showClose: true,
                    message: '删除成功',
                    type: 'success'
                })
            } else {
                this.$message({
                    showClose: true,
                    message: deleteOrderInfo.message,
                    type: 'error'
                })
            }
        },
        //订单详情
        orderDetail(info) {
            if (info.refundApplyFlag == 1 && info.refundProgress != 'reject') {
                this.$message({
                    message: '申请退款期间不可观看/下载作品内容',
                    type: 'error'
                })
                return false
            }
            this.orderDetailDrawer = true
            this.orderDetailInfo = info
        },
        //修改订单当前页
        changeOrder(pageNo) {
            this.orderPageNo = pageNo
            this.orderListData()
        },
        //获取订单列表
        async orderListData() {
            let orderInfo = await orderListData({
                buyerMobile: getLocalStorage('user-mobile'),
                pageNo: this.orderPageNo
            })
            this.orderTotalSize = orderInfo.count
            orderInfo.list.map((item) => {
                item.preview = 0
            })
            this.orderData = orderInfo.list
            if (orderInfo.count > 0) {
                this.orderDetailInfo = orderInfo.list[0]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.blue {
    color: rgb(3, 150, 249);
    line-height: 30px;
    cursor: pointer;
}

.orderDetail2::v-deep {
    .cell {
        font-size: 14px;
        padding-left: 30px !important;
    }

    .el-drawer__body {
        padding: 0 30px;
    }

    text-align: left;

    .el-drawer__header {
        font-size: 18px;
        margin-bottom: 30px;
        padding: 30px 20px 0px 30px;
        height: 48px;

        span {
            outline: none;
            font-weight: 600;
            color: #37383c !important;
        }

        .el-drawer__close-btn {
            outline: none;
        }
    }

    .el-drawer {
        min-width: 680px;
    }
}

.convertOrderModal::v-deep {
    .el-dialog {
        border-radius: 6px;
    }

    .el-dialog {
        padding: 10px 10px 15px 15px;
    }

    .el-dialog__body {
        padding: 20px 40px 15px 20px;
    }

    .el-form {
        label {
            color: #000;
        }

        .el-form-item__content {
            display: flex;
            flex: 1;
            margin-left: 0 !important;
        }

        input {
            flex: 1;
        }
    }
}

.el-button--primary {
    background-color: #ff4d6d !important;
    border-color: #ff4d6d !important;
}

.el-button--primary:active,
.el-button--primary.is-active,
.el-button--primary:hover {
    background-color: rgba(#ff4d6d, 0.9) !important;
    border-color: rgba(#ff4d6d, 0.9) !important;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:hover,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:active {
    background-color: rgba(#ff4d6d, 0.8) !important;
    border-color: rgba(#ff4d6d, 0.8) !important;
}

.orderDetail::v-deep {
    text-align: left;

    .orderDetailBox {

        overflow-y: auto;
        height: calc(100vh - 90px);

        /*修改滚动条样式*/
        &::-webkit-scrollbar {
            width: 4px;
            height: 8px;
            /**/
        }

        .el-scrollbar__bar.is-vertical {}

        &::-webkit-scrollbar-track {
            background: rgb(239, 239, 239);
            border-radius: 2px;
        }

        &::-webkit-scrollbar-thumb {
            background: #bfbfbf;
            border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: #333;
        }

        &::-webkit-scrollbar-corner {
            background: #179a16;
        }
    }

    .orderDetailCon {
        padding: 20px;
        border-top: 1px solid #f3f4f9;

        &>p {
            font-weight: 600;
            color: #37383c;
        }

        .orderDetailConItem {
            margin-top: 20px;
            line-height: 20px;
            align-items: center;
            color: #333;

            img {
                width: 90px;
                /*height: 120px;*/
                height: 90px;
                border-radius: 8px;
                margin-right: 15px;
                -o-object-fit: cover;
                object-fit: cover;
                object-position: top;
                vertical-align: top;
            }

            .conItemL {
                color: #888a95;
                width: 96px;
                margin-right: 20px;
            }

            .buy {
                width: 66px;
                border-radius: 12px;
                border: 1px solid #5addb3;
                font-size: 12px;
                color: #2dc695;
                line-height: 22px;
                box-sizing: border-box;
                text-align: center;
            }

            /*.buy{*/
            /*  border: 1px solid #32b242;*/
            /*  color: #32b242;*/
            /*  width: 64px;*/
            /*  line-height: 20px;*/
            /*  border-radius: 10px;*/
            /*  font-size: 12px;*/
            /*  text-align: center;*/
            /*  box-sizing: border-box;*/
            /*}*/
            .buy2 {
                width: 66px;
                border-radius: 12px;
                border: 1px solid #ff4d6d;
                font-size: 12px;
                color: #ff4d6d;
                line-height: 22px;
                box-sizing: border-box;
                text-align: center;
            }
        }
    }

    .el-drawer__header {
        font-size: 20px;
        margin-bottom: 30px;
        /*margin-bottom: 32px;*/
        padding: 30px 20px 0;
        height: 48px;

        span {
            outline: none;
            font-weight: 600;
            color: #37383c !important;
        }

        .el-drawer__close-btn {
            outline: none;
        }
    }

    .el-drawer {
        min-width: 480px;
    }
}

.order-list::v-deep {
    margin: 16px;

    .el-table {
        margin-bottom: 40px;

        .el-table__empty-text {
            font-size: 14px;
            color: #333;
        }

        thead {
            color: #333 !important;
            font-weight: 700;
            font-size: 12px;

            .el-table__cell {
                background-color: #fafafa !important;
            }

        }
    }

    .academy-profile-big-card {
        padding: 0 32px 32px 32px;
        background-color: #fff;
        border-radius: 4px;

        .academy-profile-title {
            color: #333;
            /*margin-bottom: 40px;*/
            margin-bottom: 20px;
            text-align: left;
            font-weight: 600;
            font-size: 16px;
            align-items: center;

            border-bottom: 1px solid #e4e9ed;

            div {
                line-height: 74px;
            }

            .btn-info {
                flex: 1;

                justify-content: flex-end;
            }

            button {
                height: 40px;
            }
        }
    }
}
</style>
